export default __webpack_public_path__ + "static/media/Path3401.db1b409b.svg";